import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';

//import { OneSignal } from '@ionic-native/onesignal';
import { Globals } from '../providers/globals';
import { HttpHelper } from '../helpers/httpHelper';
import { Storage } from '@ionic/storage';

import { BaseProvider } from '../providers/base-provider';

@Injectable()
export class PushNotificationHandlerProvider extends BaseProvider {
	constructor(
		public http: Http,	
		public globals: Globals,
		public storage: Storage,
		public httpHelper: HttpHelper,
		//private oneSignal: OneSignal,		
	) {
		super();
	}

	handlerNotifications(cb){
		// this.oneSignal.startInit(this.globals.oneSignalAppId);

		// this.oneSignal.inFocusDisplaying(this.oneSignal.OSInFocusDisplayOption.None);

		// this.oneSignal
		// .handleNotificationReceived()
		// .subscribe(jsonData => {
		// 	console.log("Entered handleNotificationReceived");
		// 	console.log(jsonData.payload.additionalData.MessageId);

		//  	this.updateReceivedCount(jsonData.payload.additionalData.MessageId)
		// });

		// this.oneSignal
		// .handleNotificationOpened()    
		// .subscribe(jsonData => {
		//   	console.log('notificationOpenedCallback: ' + JSON.stringify(jsonData));

		//   	var messageId = jsonData.notification.payload.additionalData.MessageId;

		//   	this.globals.messageId = messageId;

		//   	console.log("Entered handleNotificationOpened");

		//   	cb(jsonData);

		//   	this.updateReadCount(messageId);
		// });

		// this.oneSignal.endInit();
	}  

	updateReadCount(id){
	    this.url = this.globals.dataUrl + 'business/message/detail/read/' + id;

	    this.storage.get('loginData').then((loginData) => {
	      	this.token = loginData.access_token

		    this.http
		    .put(
		      this.url, 
		      null, 
		      this.httpHelper.configOptionsWithToken(this.token)
		    )
		    .map(res => res.json())
		    .subscribe(response => {
		        //if(typeof cb == "function") cb(response);
		    }); 
		});             
	}

	updateReceivedCount(id){
	    this.url = this.globals.dataUrl + 'business/message/detail/received/' + id;

	    this.storage.get('loginData').then((loginData) => {
	      	this.token = loginData.access_token

		    this.http
		    .put(
		      this.url, 
		      null, 
		      this.httpHelper.configOptionsWithToken(this.token)
		    )
		    .map(res => res.json())
		    .subscribe(response => {
		        //if(typeof cb == "function") cb(response);
		    }); 
		});             
	}

	subscribeToBusiness(businessId){	
		console.log("subscribeToBusiness: " + businessId);

		//this.oneSignal.sendTag("business-" + businessId, "business-" + businessId);
	}

	unsubscribeToBusiness(businessId){	
		console.log("unsubscribeToBusiness: " + businessId);
		//this.oneSignal.sendTag("business-" + businessId, null);
	}	

	subscribeUserAsBusinessAdmin(businessId){	
		console.log("subscribeToBusiness: " + businessId);

		//this.oneSignal.sendTag("businessAdmin-" + businessId, "businessAdmin-" + businessId);
	}	

	subsribeUserByRole(role){
		//this.oneSignal.sendTag("role", role);
	}
}



// WEBPACK FOOTER //
// ./src/providers/push-notification-handler.ts